export default __webpack_public_path__ + "static/media/logo.8715e124.svg";